/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import { PROMETHEAN_DARK_PURPLE, PROMETHEAN_NEUTRAL_WHITE } from '@prom/web-embers'

export const StyledHeader = styled('div')({
  height: 56,
  backgroundColor: PROMETHEAN_DARK_PURPLE,
  color: PROMETHEAN_NEUTRAL_WHITE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: -65,
  marginRight: -65,
  marginTop: -96,
  marginBottom: 40,

  '.OIDCHeader': {
    '&-fire': {
      display: 'none',
    },
  },

  '@media screen and (max-width: 446px)': {
    position: 'relative',
    height: 64,
    paddingLeft: 32,
    justifyContent: 'start',
    marginLeft: -29.5,
    marginRight: -29.5,

    '.OIDCHeader': {
      '&-prometheanLogo': {
        position: 'relative',
        width: 167,
        height: 44,
        zIndex: 1,
      },
      '&-fire': {
        display: 'block',
        position: 'absolute',
        right: 0,
        top: 0,
      },
    },
  },
})
